export default "__VITE_ASSET__9b3fc607__"